{
  "alerts_navigation": {
    "active": "Active",
    "resolved": "Resolved"
  },
  "browser_tab": {
    "add_company": "Add a Company",
    "admin": {
      "messages": "Admin - Messages"
    },
    "alerts": {
      "active": "Alerts - Active",
      "resolved": "Alerts - Resolved"
    },
    "companies": "Companies",
    "company": {
      "alert_settings": "Company - Alert Settings",
      "children": "Company - Children",
      "devices": "Company - Devices",
      "logs": "Company - Logs",
      "options": "Company - Options",
      "sites": "Company - Sites",
      "user_settings": "Company - User Settings",
      "users": "Company - Users"
    },
    "default": "Bigleaf Cloud Connect",
    "logs": "Logs",
    "not_found": "Not Found",
    "order_new_site": "Order New Site",
    "provision_new_site": "Provision New Site",
    "site": {
      "diagnostics": "Diagnostics",
      "logs": "Site - Logs",
      "overview": "Overview",
      "performance": "Performance"
    },
    "site_config": {
      "circuits": "Site Configuration - Circuits",
      "devices": "Site Configuration - Devices",
      "firewall": "Site Configuration - Firewall",
      "general": "Site Configuration",
      "lan_clients": "Site Configuration - LAN Clients",
      "lan_settings": "Site Configuration - LAN Settings",
      "rules": "Site Configuration - Custom QoS",
      "vpn": "Site Configuration - VPN",
      "wifi": "Site Configuration - Wi-Fi"
    },
    "sites": "Sites",
    "user_settings": "User Settings"
  },
  "config_navigation": {
    "circuits": "Circuits",
    "devices": "Devices",
    "firewall": "Firewall",
    "general": "General",
    "lan_clients": "LAN Clients",
    "lan_settings": "LAN Settings",
    "rules": "Custom QoS",
    "vpn": "VPN",
    "wifi": "Wi-Fi"
  },
  "logs_navigation": {
    "firewall": "Firewall logs",
    "general": "General logs",
    "vpn": "VPN logs"
  },
  "pagination": {
    "description": "{{start, number}}-{{end, number}} <secondary>of</secondary>  {{total, number}}",
    "rows_per_page": "Rows per page"
  },
  "site_navigation": {
    "configuration": "Configuration",
    "diagnostics": "Diagnostics",
    "logs": "Logs",
    "overview": "Overview",
    "performance": "Performance"
  },
  "site_selector": {
    "controls": {
      "cta": {
        "apply": "Apply"
      },
      "filter_by": {
        "label": "Filter",
        "reset": "Clear filters",
        "search": {
          "label": "Search",
          "placeholder": "Search for site"
        },
        "statuses": {
          "heading": "Filter by Status"
        }
      },
      "group_by": {
        "label": "Group",
        "option": {
          "company": "Grouped by Company (default view)",
          "status": "Grouped by Site Status",
          "ungrouped": "Ungrouped View"
        }
      },
      "settings": {
        "group_expanded_state": {
          "option": {
            "collapsed": "Collapse all groups",
            "expanded": "Expand all groups"
          }
        },
        "label": "Settings"
      },
      "sort_by": {
        "label": "Sort",
        "name": {
          "company": "Company",
          "ungrouped": "Site"
        },
        "option": {
          "alert_count_asc": "Least Alerts",
          "alert_count_desc": "Most Alerts",
          "alert_severity_asc": "Alert Severity: Ascending",
          "alert_severity_desc": "Alert Severity: Descending",
          "name_asc": "$t(site_selector.controls.sort_by.name.{{groupBy}}) name: Ascending",
          "name_desc": "$t(site_selector.controls.sort_by.name.{{groupBy}}) name: Descending"
        }
      }
    },
    "lists": {
      "company_list": {
        "error": "Unable to load companies.",
        "more": "More companies ({{count}} remaining)"
      },
      "notice": {
        "no_sites": "There are no Sites that match your search. Change the search filters and try again.",
        "service_error": "Something went wrong and we can't retrieve the Sites. Try again in a few minutes. If the issue continues, contact your network administrator"
      },
      "site_group": {
        "sites_count": "{{sites_count}} sites"
      },
      "site_list": {
        "error": "Unable to load sites.",
        "more": "More sites ({{count}} remaining)"
      },
      "site_list_item": {
        "context_menu": {
          "label": "More",
          "mute_alerts": "Mute all alerts for this site"
        }
      },
      "status_list": {
        "error": "Unable to load statuses.",
        "status": "Status:"
      }
    }
  }
}
